import { useTranslation } from 'i18n';
import { addError } from 'monitor';
import { IconButton, Stack, TypographyIcon, useBreakpoint } from 'ui';
import { Download, InfoOutlined } from 'ui/icons';
import { downloadImageFromUrl } from '../../../files/utils/downloadImageFromUrl/downloadImageFromUrl';

import { AiFeedbackAlert } from '../AiFeedbackAlert/AiFeedbackAlert';

export const HelpAndFeedbackBar = ({
  helpText,
  isAiFeedbackEnabled,
  imageSrc,
}: {
  helpText: string;
  isAiFeedbackEnabled: boolean;
  imageSrc: string;
}) => {
  const { t } = useTranslation('features');
  const { isMobile } = useBreakpoint();

  const handleDownload = async () => {
    try {
      await downloadImageFromUrl(imageSrc);
    } catch (error) {
      addError(error);
    }
  };

  return (
    <Stack
      spacing={1}
      direction={isMobile ? 'column' : 'row'}
      sx={{
        justifyContent: 'space-between',
        mb: 1,
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: 'center',
        }}
      >
        <IconButton
          size="small"
          onClick={handleDownload}
          aria-label={t('annotations.helpAndFeedbackBar.downloadFullImageAriaLabel')}
        >
          <Download />
        </IconButton>
        <TypographyIcon icon={InfoOutlined} size="small" color="secondary" fontSize="small">
          {helpText}
        </TypographyIcon>
      </Stack>
      {isAiFeedbackEnabled ? <AiFeedbackAlert /> : null}
    </Stack>
  );
};
